module.exports = __webpack_public_path__ + "static/media/IMG_1403.53924ea8.JPG";